import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { UtilsService } from "../services/utils.service";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";

@Injectable()
export class WafInterceptor implements HttpInterceptor {
  constructor(private readonly _utilSrv: UtilsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let reqClone = request;
    const token = this._utilSrv.wafToken.getValue();
    if (!token || !reqClone.url.includes(environment.api) ) {
      return next.handle(reqClone);
    }
    reqClone = reqClone.clone({
      setHeaders: {
        "X-Aws-Waf-Token": token,
      },
    });
    return next.handle(reqClone);
  }
}
